import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ModalDialogComponent } from '../components/modal-dialog/modal-dialog.component';
import { HomeDelivery } from '../models/home-delivery';
import { IncreaseItemCountDialogComponent } from '../components/increase-item-count-dialog/increase-item-count-dialog.component';
import { Constants } from '../constants';
import { BatchScanningDialogComponent } from "../components/batch-scanning-dialog/batch-scanning-dialog.component";
import { lastValueFrom } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(private matDialog: MatDialog,
              private translate: TranslateService) {
  }

  showAlert(title: string, text: string, positiveButton: string, callback: VoidFunction): void {
    const dialogRef = this.matDialog.open(ModalDialogComponent, {
      panelClass: 'modal-dialog',
      closeOnNavigation: true,
      data: {
        title,
        text,
        positiveButton,
        cancelButton: undefined
      }
    });
    dialogRef.afterClosed().subscribe(result => callback());
  }

  showConfirmationModal(title: string, text: string, positiveButton?: string, cancelButton?: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const dialogRef = this.matDialog.open(ModalDialogComponent, {
        panelClass: 'modal-dialog',
        disableClose: true,
        data: {
          title,
          text,
          positiveButton: positiveButton || this.translate.instant('ok'),
          cancelButton: cancelButton || this.translate.instant('cancel')
        }
      });
      dialogRef.afterClosed().subscribe(result => resolve(result));
    });
  }

  showScannerPausedModal(callback: VoidFunction): void {
    const dialogRef = this.matDialog.open(ModalDialogComponent, {
      panelClass: 'modal-dialog',
      closeOnNavigation: true,
      data: {
        title: this.translate.instant('scanner.pausedTitle'),
        text: this.translate.instant('scanner.pausedText'),
        positiveButton: this.translate.instant('scanner.resume'),
        cancelButton: undefined
      }
    });
    dialogRef.afterClosed().subscribe(result => callback());
  }

  showLogoutModal(): Promise<boolean> {
    const dialogRef = this.matDialog.open(ModalDialogComponent, {
      panelClass: 'modal-dialog',
      closeOnNavigation: true,
      data: {
        title: this.translate.instant('logoutDialog.logoutTitle'),
        text: this.translate.instant('logoutDialog.logoutText'),
        positiveButton: this.translate.instant('logoutDialog.logout'),
        cancelButton: this.translate.instant('logoutDialog.cancel')
      }
    });
    return dialogRef.afterClosed().toPromise();
  }

  showIncreaseItemCountModal(homeDelivery: HomeDelivery): Promise<number> {
    const dialogRef = this.matDialog.open<IncreaseItemCountDialogComponent, any, number>(IncreaseItemCountDialogComponent, {
      panelClass: 'modal-dialog',
      closeOnNavigation: true,
      data: {
        minItemCount: homeDelivery.status.total,
        maxItemCount: homeDelivery.status.total + Constants.maxAdditionalItemCount
      }
    });
    return dialogRef.afterClosed().toPromise();
  }

  showBatchScanningModal(homeDelivery: HomeDelivery): Promise<number> {
    const dialogRef = this.matDialog.open<BatchScanningDialogComponent, any, number>(BatchScanningDialogComponent, {
      panelClass: 'modal-dialog',
      closeOnNavigation: true,
      disableClose: true,
      autoFocus: 'first-tabbable',
      data: {
        homeDelivery: homeDelivery
      }
    });
    return lastValueFrom(dialogRef.afterClosed());
  }
}
